// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperNewsStory-cls1_9mX","cls2":"PaperNewsStory-cls2_Z-g PaperNewsStory-cls1_9mX","variant-dense":"PaperNewsStory-variant-dense_v3f"};